import { useEffect, useRef } from "react";

export default function RainCanvas({ className = "" }) {
    const ref = useRef(null);

    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
        const canvas = ref.current;
        if (!canvas) return undefined;
        const ctx = canvas.getContext("2d");
        let raf;
        let w = 0;
        let h = 0;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);

        const drops = Array.from({ length: 70 }, () => ({
            x: Math.random(),
            y: Math.random(),
            len: 12 + Math.random() * 26,
            speed: 0.35 + Math.random() * 0.9,
            gold: Math.random() > 0.6,
            alpha: 0.08 + Math.random() * 0.22,
        }));

        const resize = () => {
            w = canvas.offsetWidth;
            h = canvas.offsetHeight;
            canvas.width = w * dpr;
            canvas.height = h * dpr;
            ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        };
        resize();
        window.addEventListener("resize", resize);

        const draw = () => {
            ctx.clearRect(0, 0, w, h);
            drops.forEach((d) => {
                d.y += d.speed / 100;
                if (d.y > 1.05) {
                    d.y = -0.05;
                    d.x = Math.random();
                }
                const x = d.x * w;
                const y = d.y * h;
                ctx.strokeStyle = d.gold
                    ? `rgba(212, 175, 55, ${d.alpha})`
                    : `rgba(0, 122, 255, ${d.alpha})`;
                ctx.lineWidth = 1;
                ctx.beginPath();
                ctx.moveTo(x, y);
                ctx.lineTo(x - 2, y + d.len);
                ctx.stroke();
            });
            raf = requestAnimationFrame(draw);
        };
        raf = requestAnimationFrame(draw);

        return () => {
            cancelAnimationFrame(raf);
            window.removeEventListener("resize", resize);
        };
    }, []);

    return <canvas ref={ref} className={className} aria-hidden="true" />;
}
